import { useState, useEffect, useRef, useCallback } from 'react';
import api from '../../../services/api';

export const useLedgerSearch = ({
  searchValue,
  branchId,
  enabled = true,
  debounceMs = 300,
  activeGroupIds = [],
  activeSubGroupIds = []
}) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef(null);
  const abortRef = useRef(null);

  // Arrays ko stable ref mein rakho taaki dependency issue na ho
  const activeGroupIdsRef = useRef(activeGroupIds);
  const activeSubGroupIdsRef = useRef(activeSubGroupIds);

  useEffect(() => {
    activeGroupIdsRef.current = activeGroupIds;
  }, [activeGroupIds]);

  useEffect(() => {
    activeSubGroupIdsRef.current = activeSubGroupIds;
  }, [activeSubGroupIds]);

  useEffect(() => {
    if (!enabled || !searchValue || searchValue.trim().length < 1) {
      setResults([]);
      return;
    }

    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (abortRef.current) abortRef.current.abort();

    debounceRef.current = setTimeout(async () => {
      const controller = new AbortController();
      abortRef.current = controller;

      setLoading(true);
      try {
        const res = await api.post(
          'ledgers/fetch-ledgers',
          {
            value: searchValue.trim(),
            branchId,
            group_ids: activeGroupIdsRef.current,
            sub_group_ids: activeSubGroupIdsRef.current,
          },
          { signal: controller.signal }
        );

        if (res.data.success) {
          setResults(res.data.data || []);
        }
      } catch (err) {
        if (err.name !== 'CanceledError' && err.name !== 'AbortError') {
          console.error('[useLedgerSearch] error:', err);
        }
      } finally {
        setLoading(false);
      }
    }, debounceMs);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [searchValue, branchId, enabled, debounceMs]);
  // ↑ activeGroupIds/activeSubGroupIds yahan nahi — ref se latest value milti rehti hai

  return { results, loading };
};